const DeviceMenu = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const hamBurger = document.querySelector('.hamburger');
        const overlay = document.querySelectorAll('.mbnav__backdrop, .mbnav__close');
        const body = document.body;
        const mbnav = document.querySelector('.mbnav');
        const transparentHeader = document.querySelector('.main-header.transparent-header');

        function menuClose() {
            hamBurger.classList.remove('is-clicked');
            body.classList.remove('scroll-fixed');
            mbnav.classList.remove('is-open');
            mbnav.querySelectorAll('.menu-wrap li').forEach(li => li.classList.remove('is-open'));
            document.querySelector('.mbnav__inner > .menu-wrap').style.setProperty('--leftSlide', '0');
            transparentHeader && transparentHeader.classList.remove('mb-stuck');
        }

        const searchButton = document.querySelector('header.main-header .header-search .header-search-btn');
        const searchWrap = document.querySelector('header.main-header .h-search-wrap');

        searchButton.addEventListener('click', function() {
            if (hamBurger.classList.contains('is-clicked')) {
                menuClose();
            }
        });

        // Overlay click
        overlay.forEach(el => {
            el.addEventListener('click', menuClose);
        });

        // Hamburger click
        hamBurger.addEventListener('click', () => {
            if (hamBurger.classList.contains('is-clicked')) {
                menuClose();
            } else {
                hamBurger.classList.add('is-clicked');
                mbnav.classList.add('is-open');
                body.classList.add('scroll-fixed');
                transparentHeader && transparentHeader.classList.add('mb-stuck');
                searchButton.classList.remove('is-click');
                searchWrap.classList.remove('is-open');
            }
        });

        // Mark has-sub
        const mbnavState = document.querySelector('.mbnav__state');
        const clickable = mbnavState ? mbnavState.getAttribute('data-clickable') === 'true' : false;
        const menuItems = document.querySelectorAll('.mbnav ul.menu > li');

        menuItems.forEach(li => {
            if (li.querySelector('ul')) {
                li.classList.add('has-sub');
                const ul = li.querySelector('ul');
                ul.classList.add('sub-menu');
                const link = li.querySelector('a');
                if (link) {
                    const caret = document.createElement('em');
                    caret.className = 'mbnav__caret';
                    link.insertAdjacentElement('afterend', caret);
                }

                // Insert Back and Parent Title
                if (ul) {
                    const text = link ? link.textContent : '';
                    const parentTitle = document.createElement('li');
                    parentTitle.className = 'parent-title';
                    parentTitle.textContent = text;

                    const backClick = document.createElement('li');
                    backClick.className = 'back-click';
                    backClick.textContent = 'Main Menu';

                    ul.prepend(parentTitle);
                    ul.prepend(backClick);
                }
            }
        });

        // Handle caret triggers
        const carets = document.querySelectorAll('.mbnav .has-sub>.mbnav__caret');
        carets.forEach(caret => {
            if (clickable) {
                caret.classList.add('trigger-caret');
            } else {
                const link = caret.previousElementSibling;
                if (link && link.tagName === 'A') {
                    link.classList.add('trigger-caret');
                    link.setAttribute('href', 'javascript:;');
                }
            }
        });

        // Wrap elements
        const inner = document.querySelector('.mbnav__inner');
        if (inner) {
            const wrapper = document.createElement('div');
            wrapper.className = 'menu-wrap';
            const innerWrap = document.createElement('div');
            innerWrap.className = 'menu-inner';

            while (inner.firstChild) {
                innerWrap.appendChild(inner.firstChild);
            }

            wrapper.appendChild(innerWrap);
            inner.appendChild(wrapper);

            document.querySelectorAll('.mbnav__inner ul.menu > li.has-sub > ul').forEach(ul => {
                const wrap = document.createElement('div');
                wrap.className = 'menu-wrap';
                const innerDiv = document.createElement('div');
                innerDiv.className = 'menu-inner';

                ul.parentNode.insertBefore(wrap, ul);
                wrap.appendChild(innerDiv);
                innerDiv.appendChild(ul);
            });
        }

        // Open sub-menu
        document.querySelectorAll('.mbnav .has-sub>.trigger-caret, .mbnav__inner a[href="#"]').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const li = trigger.closest('li');
                const siblings = li.parentElement.children;
                Array.from(siblings).forEach(sib => {
                    if (sib !== li) {
                        sib.classList.remove('is-open');
                    }
                });
                li.classList.add('is-open');
                body.classList.add('scroll-fixed');
            });
        });

        // Forward slide
        document.querySelectorAll('.mbnav__inner .mbnav__caret, .mbnav__inner a[href="#"]').forEach(caret => {
            caret.addEventListener('click', () => {
                const menuLeftMove = document.querySelector('.mbnav__inner > .menu-wrap');
                const current = parseInt(getComputedStyle(menuLeftMove).getPropertyValue('--leftSlide')) || 0;
                menuLeftMove.style.setProperty('--leftSlide', (current + 100) + '%');
            });
        });

        // Backward slide
        document.querySelectorAll('.mbnav__inner .back-click').forEach(backBtn => {
            backBtn.addEventListener('click', () => {
                const li = backBtn.closest('li.has-sub');
                if (li) {
                    li.classList.remove('is-open');
                }

                const menuLeftMove = document.querySelector('.mbnav__inner > .menu-wrap');
                const current = parseInt(getComputedStyle(menuLeftMove).getPropertyValue('--leftSlide')) || 0;
                menuLeftMove.style.setProperty('--leftSlide', (current - 100) + '%');
            });
        });

        // Padding adjustment
        const menuInner = document.querySelector('.mbnav .menu-wrap');
        if (menuInner) {
            const header = document.querySelector('header.main-header');
            menuInner.style.setProperty('--hasPadding', header ? header.offsetHeight + 'px' : '0px');
        }
    });

    window.addEventListener('resize', () => {
        const menuInner = document.querySelector('.mbnav .menu-wrap');
        if (menuInner) {
            const header = document.querySelector('header.main-header');
            menuInner.style.setProperty('--hasPadding', header ? header.offsetHeight + 'px' : '0px');
        }
    });
};

export default DeviceMenu;